export default "__VITE_ASSET__DXGVb3Rn__"